<template>
    <div class="flex uppercase">
        <div class="flex">
            <img class="mr-3" src="../assets/images/logo.svg" alt="logo" />
            <div class="flex flex-col">
                <span class="font-bold text-xl">Microtones</span>
                <span class="font-semibold text-xxs">Online monitor system</span>
            </div>
        </div>
        <div class="border-2 border-white ml-4">
            <p class="px-2 py-1 font-bold text-xl">
                BETA
            </p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Logo',
}
</script>